import { UserTextCustomizations } from '@repo/types';
import { createRoot } from 'react-dom/client';
import { getYesAttribute } from '@repo/widget-utils/attributes/attribute-helper';
import RequestTour from 'src/widgets/activities/request-tour/RequestTour';
import BilberryCustomElement from 'src/widgets/BilberryCustomElement';
import { WidgetWrapper } from 'src/widgets/WidgetWrapper';

class BilberryRequestTour extends BilberryCustomElement {
    protected renderWidget(): void {
        const titleTextCustomizationKey = this.getAttribute(
            'title-text-customization-key',
        ) as keyof UserTextCustomizations;
        const submitButtonTextCustomizationKey = this.getAttribute(
            'submit-button-text-customization-key',
        ) as keyof UserTextCustomizations;
        const thankYouTextCustomizationKey = this.getAttribute(
            'thank-you-text-customization-key',
        ) as keyof UserTextCustomizations;
        const expandArrowInside = getYesAttribute(this, 'expand-arrow-inside');
        const hideRequestDate = getYesAttribute(this, 'hide-request-date');
        const hideQuantityPicker = getYesAttribute(this, 'hide-quantity-picker');
        const positionOffscreen = getYesAttribute(this, 'position-offscreen');

        createRoot(this._mountPoint).render(
            <WidgetWrapper
                mountPoint={this._mountPoint}
                popoverMountPoint={this._popoverMountPoint}
                shadowRoot={this._shadowRoot}
            >
                <RequestTour
                    titleTextCustomizationKey={titleTextCustomizationKey ?? undefined}
                    submitButtonTextCustomizationKey={submitButtonTextCustomizationKey ?? undefined}
                    thankYouTextCustomizationKey={thankYouTextCustomizationKey ?? undefined}
                    expandArrowInside={expandArrowInside}
                    hideRequestDate={hideRequestDate}
                    hideQuantityPicker={hideQuantityPicker}
                    positionOffscreen={positionOffscreen}
                />
            </WidgetWrapper>,
        );
    }
}

export default function defineCustomElement(): void {
    customElements.define('bilberry-request-tour', BilberryRequestTour);
}
